module.exports = __webpack_public_path__ + "travel_classic-beach-summer_1.jpg";